import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";

export const deductionApi = createApi({
  reducerPath: "deductionApi",
  tagTypes: ["Deduction", "OverrideDeduction"],
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    addDeduction: builder.mutation({
      query: (payload) => ({
        url: '/deduction/portal/tech',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ["Deduction"],
    }),

    addTechPayrollDeduction: builder.mutation({
      query: (payload) => ({
        url: "/deduction/portal/weekly-deduction",
        method: "POST",
        body: payload,
      }),
    }),

    addAdminDeductionReimbursement: builder.mutation({
      query: (payload) => ({
        url: "/deduction/portal/admin",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Deduction"],
    }),

    // Override Backend deductions (thread #1644, 2026-10-16). A separate family
    // from the four above on purpose: these write portal_app.override_deductions
    // and take the money out of the OVERRIDE backend (SummerNumbers
    // totaltierhiringoverride via md_transactions), not out of the rep's regular
    // commission backend. Different table, different engine, different money.
    getOverrideDeductionTargets: builder.query({
      query: ({ year }) => ({
        url: "/deduction/portal/admin/override/targets",
        params: { year },
      }),
    }),

    getOverrideDeductions: builder.query({
      query: ({ year, scope }) => ({
        url: "/deduction/portal/admin/override",
        params: scope ? { year, scope } : { year },
      }),
      providesTags: ["OverrideDeduction"],
    }),

    addOverrideDeduction: builder.mutation({
      query: (payload) => ({
        url: "/deduction/portal/admin/override",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["OverrideDeduction", "Deduction"],
    }),

    voidOverrideDeduction: builder.mutation({
      query: ({ id }) => ({
        url: `/deduction/portal/admin/override/${id}/void`,
        method: "PATCH",
      }),
      invalidatesTags: ["OverrideDeduction", "Deduction"],
    }),
  }),
});

export const {
  useAddDeductionMutation,
  useAddTechPayrollDeductionMutation,
  useAddAdminDeductionReimbursementMutation,
  useGetOverrideDeductionTargetsQuery,
  useGetOverrideDeductionsQuery,
  useAddOverrideDeductionMutation,
  useVoidOverrideDeductionMutation,
} = deductionApi;
